import _typeof from "/Users/begin/work/boss-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/typeof";
import _asyncToGenerator from "/Users/begin/work/boss-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
function _regeneratorRuntime() {
  "use strict";

  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */
  _regeneratorRuntime = function _regeneratorRuntime() {
    return e;
  };
  var t,
    e = {},
    r = Object.prototype,
    n = r.hasOwnProperty,
    o = Object.defineProperty || function (t, e, r) {
      t[e] = r.value;
    },
    i = "function" == typeof Symbol ? Symbol : {},
    a = i.iterator || "@@iterator",
    c = i.asyncIterator || "@@asyncIterator",
    u = i.toStringTag || "@@toStringTag";
  function define(t, e, r) {
    return Object.defineProperty(t, e, {
      value: r,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), t[e];
  }
  try {
    define({}, "");
  } catch (t) {
    define = function define(t, e, r) {
      return t[e] = r;
    };
  }
  function wrap(t, e, r, n) {
    var i = e && e.prototype instanceof Generator ? e : Generator,
      a = Object.create(i.prototype),
      c = new Context(n || []);
    return o(a, "_invoke", {
      value: makeInvokeMethod(t, r, c)
    }), a;
  }
  function tryCatch(t, e, r) {
    try {
      return {
        type: "normal",
        arg: t.call(e, r)
      };
    } catch (t) {
      return {
        type: "throw",
        arg: t
      };
    }
  }
  e.wrap = wrap;
  var h = "suspendedStart",
    l = "suspendedYield",
    f = "executing",
    s = "completed",
    y = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  var p = {};
  define(p, a, function () {
    return this;
  });
  var d = Object.getPrototypeOf,
    v = d && d(d(values([])));
  v && v !== r && n.call(v, a) && (p = v);
  var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p);
  function defineIteratorMethods(t) {
    ["next", "throw", "return"].forEach(function (e) {
      define(t, e, function (t) {
        return this._invoke(e, t);
      });
    });
  }
  function AsyncIterator(t, e) {
    function invoke(r, o, i, a) {
      var c = tryCatch(t[r], t, o);
      if ("throw" !== c.type) {
        var u = c.arg,
          h = u.value;
        return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) {
          invoke("next", t, i, a);
        }, function (t) {
          invoke("throw", t, i, a);
        }) : e.resolve(h).then(function (t) {
          u.value = t, i(u);
        }, function (t) {
          return invoke("throw", t, i, a);
        });
      }
      a(c.arg);
    }
    var r;
    o(this, "_invoke", {
      value: function value(t, n) {
        function callInvokeWithMethodAndArg() {
          return new e(function (e, r) {
            invoke(t, n, e, r);
          });
        }
        return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
      }
    });
  }
  function makeInvokeMethod(e, r, n) {
    var o = h;
    return function (i, a) {
      if (o === f) throw Error("Generator is already running");
      if (o === s) {
        if ("throw" === i) throw a;
        return {
          value: t,
          done: !0
        };
      }
      for (n.method = i, n.arg = a;;) {
        var c = n.delegate;
        if (c) {
          var u = maybeInvokeDelegate(c, n);
          if (u) {
            if (u === y) continue;
            return u;
          }
        }
        if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) {
          if (o === h) throw o = s, n.arg;
          n.dispatchException(n.arg);
        } else "return" === n.method && n.abrupt("return", n.arg);
        o = f;
        var p = tryCatch(e, r, n);
        if ("normal" === p.type) {
          if (o = n.done ? s : l, p.arg === y) continue;
          return {
            value: p.arg,
            done: n.done
          };
        }
        "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg);
      }
    };
  }
  function maybeInvokeDelegate(e, r) {
    var n = r.method,
      o = e.iterator[n];
    if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y;
    var i = tryCatch(o, e.iterator, r.arg);
    if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y;
    var a = i.arg;
    return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y);
  }
  function pushTryEntry(t) {
    var e = {
      tryLoc: t[0]
    };
    1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
  }
  function resetTryEntry(t) {
    var e = t.completion || {};
    e.type = "normal", delete e.arg, t.completion = e;
  }
  function Context(t) {
    this.tryEntries = [{
      tryLoc: "root"
    }], t.forEach(pushTryEntry, this), this.reset(!0);
  }
  function values(e) {
    if (e || "" === e) {
      var r = e[a];
      if (r) return r.call(e);
      if ("function" == typeof e.next) return e;
      if (!isNaN(e.length)) {
        var o = -1,
          i = function next() {
            for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next;
            return next.value = t, next.done = !0, next;
          };
        return i.next = i;
      }
    }
    throw new TypeError(_typeof(e) + " is not iterable");
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", {
    value: GeneratorFunctionPrototype,
    configurable: !0
  }), o(GeneratorFunctionPrototype, "constructor", {
    value: GeneratorFunction,
    configurable: !0
  }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) {
    var e = "function" == typeof t && t.constructor;
    return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name));
  }, e.mark = function (t) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t;
  }, e.awrap = function (t) {
    return {
      __await: t
    };
  }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () {
    return this;
  }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) {
    void 0 === i && (i = Promise);
    var a = new AsyncIterator(wrap(t, r, n, o), i);
    return e.isGeneratorFunction(r) ? a : a.next().then(function (t) {
      return t.done ? t.value : a.next();
    });
  }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () {
    return this;
  }), define(g, "toString", function () {
    return "[object Generator]";
  }), e.keys = function (t) {
    var e = Object(t),
      r = [];
    for (var n in e) r.push(n);
    return r.reverse(), function next() {
      for (; r.length;) {
        var t = r.pop();
        if (t in e) return next.value = t, next.done = !1, next;
      }
      return next.done = !0, next;
    };
  }, e.values = values, Context.prototype = {
    constructor: Context,
    reset: function reset(e) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t);
    },
    stop: function stop() {
      this.done = !0;
      var t = this.tryEntries[0].completion;
      if ("throw" === t.type) throw t.arg;
      return this.rval;
    },
    dispatchException: function dispatchException(e) {
      if (this.done) throw e;
      var r = this;
      function handle(n, o) {
        return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o;
      }
      for (var o = this.tryEntries.length - 1; o >= 0; --o) {
        var i = this.tryEntries[o],
          a = i.completion;
        if ("root" === i.tryLoc) return handle("end");
        if (i.tryLoc <= this.prev) {
          var c = n.call(i, "catchLoc"),
            u = n.call(i, "finallyLoc");
          if (c && u) {
            if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
            if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
          } else if (c) {
            if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
          } else {
            if (!u) throw Error("try statement without catch or finally");
            if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
          }
        }
      }
    },
    abrupt: function abrupt(t, e) {
      for (var r = this.tryEntries.length - 1; r >= 0; --r) {
        var o = this.tryEntries[r];
        if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
          var i = o;
          break;
        }
      }
      i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
      var a = i ? i.completion : {};
      return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a);
    },
    complete: function complete(t, e) {
      if ("throw" === t.type) throw t.arg;
      return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y;
    },
    finish: function finish(t) {
      for (var e = this.tryEntries.length - 1; e >= 0; --e) {
        var r = this.tryEntries[e];
        if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y;
      }
    },
    "catch": function _catch(t) {
      for (var e = this.tryEntries.length - 1; e >= 0; --e) {
        var r = this.tryEntries[e];
        if (r.tryLoc === t) {
          var n = r.completion;
          if ("throw" === n.type) {
            var o = n.arg;
            resetTryEntry(r);
          }
          return o;
        }
      }
      throw Error("illegal catch attempt");
    },
    delegateYield: function delegateYield(e, r, n) {
      return this.delegate = {
        iterator: values(e),
        resultName: r,
        nextLoc: n
      }, "next" === this.method && (this.arg = t), y;
    }
  }, e;
}
import $ from '../../utils/ajax';
function get_cta_wan(_x) {
  return _get_cta_wan.apply(this, arguments);
}
function _get_cta_wan() {
  _get_cta_wan = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(params) {
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          return _context.abrupt("return", $.getJSON("/v1/company/get_cta_wan/", params));
        case 1:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return _get_cta_wan.apply(this, arguments);
}
function create_cta_wan(_x2) {
  return _create_cta_wan.apply(this, arguments);
}
function _create_cta_wan() {
  _create_cta_wan = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2(params) {
    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          return _context2.abrupt("return", $.post("/v1/company/create_cta_wan/", params));
        case 1:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return _create_cta_wan.apply(this, arguments);
}
function update_cta_wan(_x3) {
  return _update_cta_wan.apply(this, arguments);
}
function _update_cta_wan() {
  _update_cta_wan = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3(params) {
    return _regeneratorRuntime().wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          return _context3.abrupt("return", $.post("/v1/company/update_cta_wan/", params));
        case 1:
        case "end":
          return _context3.stop();
      }
    }, _callee3);
  }));
  return _update_cta_wan.apply(this, arguments);
}
function delete_cta_wan(_x4) {
  return _delete_cta_wan.apply(this, arguments);
}
function _delete_cta_wan() {
  _delete_cta_wan = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4(params) {
    return _regeneratorRuntime().wrap(function _callee4$(_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          return _context4.abrupt("return", $.post("/v1/company/delete_cta_wan/", params));
        case 1:
        case "end":
          return _context4.stop();
      }
    }, _callee4);
  }));
  return _delete_cta_wan.apply(this, arguments);
}
function get_available_ports_for_wan(_x5) {
  return _get_available_ports_for_wan.apply(this, arguments);
}
function _get_available_ports_for_wan() {
  _get_available_ports_for_wan = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee5(params) {
    return _regeneratorRuntime().wrap(function _callee5$(_context5) {
      while (1) switch (_context5.prev = _context5.next) {
        case 0:
          return _context5.abrupt("return", $.getJSON("/v1/company/get_available_ports_for_wan/", params));
        case 1:
        case "end":
          return _context5.stop();
      }
    }, _callee5);
  }));
  return _get_available_ports_for_wan.apply(this, arguments);
}
function get_isp_dict(_x6) {
  return _get_isp_dict.apply(this, arguments);
}
function _get_isp_dict() {
  _get_isp_dict = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee6(params) {
    return _regeneratorRuntime().wrap(function _callee6$(_context6) {
      while (1) switch (_context6.prev = _context6.next) {
        case 0:
          return _context6.abrupt("return", $.getJSON("/v1/company/get_isp_dict/", params));
        case 1:
        case "end":
          return _context6.stop();
      }
    }, _callee6);
  }));
  return _get_isp_dict.apply(this, arguments);
}
function check_lan_only(_x7) {
  return _check_lan_only.apply(this, arguments);
}
function _check_lan_only() {
  _check_lan_only = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee7(params) {
    return _regeneratorRuntime().wrap(function _callee7$(_context7) {
      while (1) switch (_context7.prev = _context7.next) {
        case 0:
          return _context7.abrupt("return", $.post("/v1/company/check_lan_only/", params));
        case 1:
        case "end":
          return _context7.stop();
      }
    }, _callee7);
  }));
  return _check_lan_only.apply(this, arguments);
}
function get_cta_lan(_x8) {
  return _get_cta_lan.apply(this, arguments);
}
function _get_cta_lan() {
  _get_cta_lan = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee8(params) {
    return _regeneratorRuntime().wrap(function _callee8$(_context8) {
      while (1) switch (_context8.prev = _context8.next) {
        case 0:
          return _context8.abrupt("return", $.getJSON("/v1/company/get_cta_lan/", params));
        case 1:
        case "end":
          return _context8.stop();
      }
    }, _callee8);
  }));
  return _get_cta_lan.apply(this, arguments);
}
function get_cta_wifi(_x9) {
  return _get_cta_wifi.apply(this, arguments);
}
function _get_cta_wifi() {
  _get_cta_wifi = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee9(params) {
    return _regeneratorRuntime().wrap(function _callee9$(_context9) {
      while (1) switch (_context9.prev = _context9.next) {
        case 0:
          return _context9.abrupt("return", $.getJSON("/v1/company/get_cta_wifi/", params));
        case 1:
        case "end":
          return _context9.stop();
      }
    }, _callee9);
  }));
  return _get_cta_wifi.apply(this, arguments);
}
function create_cta_lan(_x10) {
  return _create_cta_lan.apply(this, arguments);
}
function _create_cta_lan() {
  _create_cta_lan = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee10(params) {
    return _regeneratorRuntime().wrap(function _callee10$(_context10) {
      while (1) switch (_context10.prev = _context10.next) {
        case 0:
          return _context10.abrupt("return", $.post("/v1/company/create_cta_lan/", params));
        case 1:
        case "end":
          return _context10.stop();
      }
    }, _callee10);
  }));
  return _create_cta_lan.apply(this, arguments);
}
function update_cta_lan(_x11) {
  return _update_cta_lan.apply(this, arguments);
}
function _update_cta_lan() {
  _update_cta_lan = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee11(params) {
    return _regeneratorRuntime().wrap(function _callee11$(_context11) {
      while (1) switch (_context11.prev = _context11.next) {
        case 0:
          return _context11.abrupt("return", $.post("/v1/company/update_cta_lan/", params));
        case 1:
        case "end":
          return _context11.stop();
      }
    }, _callee11);
  }));
  return _update_cta_lan.apply(this, arguments);
}
function delete_cta_lan(_x12) {
  return _delete_cta_lan.apply(this, arguments);
}
function _delete_cta_lan() {
  _delete_cta_lan = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee12(params) {
    return _regeneratorRuntime().wrap(function _callee12$(_context12) {
      while (1) switch (_context12.prev = _context12.next) {
        case 0:
          return _context12.abrupt("return", $.post("/v1/company/delete_cta_lan/", params));
        case 1:
        case "end":
          return _context12.stop();
      }
    }, _callee12);
  }));
  return _delete_cta_lan.apply(this, arguments);
}
function get_cta_static_ip(_x13) {
  return _get_cta_static_ip.apply(this, arguments);
}
function _get_cta_static_ip() {
  _get_cta_static_ip = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee13(params) {
    return _regeneratorRuntime().wrap(function _callee13$(_context13) {
      while (1) switch (_context13.prev = _context13.next) {
        case 0:
          return _context13.abrupt("return", $.getJSON("/v1/company/get_cta_static_ip/", params));
        case 1:
        case "end":
          return _context13.stop();
      }
    }, _callee13);
  }));
  return _get_cta_static_ip.apply(this, arguments);
}
function create_cta_static_ip(_x14) {
  return _create_cta_static_ip.apply(this, arguments);
}
function _create_cta_static_ip() {
  _create_cta_static_ip = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee14(params) {
    return _regeneratorRuntime().wrap(function _callee14$(_context14) {
      while (1) switch (_context14.prev = _context14.next) {
        case 0:
          return _context14.abrupt("return", $.post("/v1/company/create_cta_static_ip/", params));
        case 1:
        case "end":
          return _context14.stop();
      }
    }, _callee14);
  }));
  return _create_cta_static_ip.apply(this, arguments);
}
function update_cta_static_ip(_x15) {
  return _update_cta_static_ip.apply(this, arguments);
}
function _update_cta_static_ip() {
  _update_cta_static_ip = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee15(params) {
    return _regeneratorRuntime().wrap(function _callee15$(_context15) {
      while (1) switch (_context15.prev = _context15.next) {
        case 0:
          return _context15.abrupt("return", $.post("/v1/company/update_cta_static_ip/", params));
        case 1:
        case "end":
          return _context15.stop();
      }
    }, _callee15);
  }));
  return _update_cta_static_ip.apply(this, arguments);
}
function delete_cta_static_ip(_x16) {
  return _delete_cta_static_ip.apply(this, arguments);
}
function _delete_cta_static_ip() {
  _delete_cta_static_ip = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee16(params) {
    return _regeneratorRuntime().wrap(function _callee16$(_context16) {
      while (1) switch (_context16.prev = _context16.next) {
        case 0:
          return _context16.abrupt("return", $.post("/v1/company/delete_cta_static_ip/", params));
        case 1:
        case "end":
          return _context16.stop();
      }
    }, _callee16);
  }));
  return _delete_cta_static_ip.apply(this, arguments);
}
function get_ap_static_ip(_x17) {
  return _get_ap_static_ip.apply(this, arguments);
}
function _get_ap_static_ip() {
  _get_ap_static_ip = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee17(params) {
    return _regeneratorRuntime().wrap(function _callee17$(_context17) {
      while (1) switch (_context17.prev = _context17.next) {
        case 0:
          return _context17.abrupt("return", $.getJSON("/v1/company/get_ap_static_ip/", params));
        case 1:
        case "end":
          return _context17.stop();
      }
    }, _callee17);
  }));
  return _get_ap_static_ip.apply(this, arguments);
}
function create_ap_static_ip(_x18) {
  return _create_ap_static_ip.apply(this, arguments);
}
function _create_ap_static_ip() {
  _create_ap_static_ip = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee18(params) {
    return _regeneratorRuntime().wrap(function _callee18$(_context18) {
      while (1) switch (_context18.prev = _context18.next) {
        case 0:
          return _context18.abrupt("return", $.post("/v1/company/create_ap_static_ip/", params));
        case 1:
        case "end":
          return _context18.stop();
      }
    }, _callee18);
  }));
  return _create_ap_static_ip.apply(this, arguments);
}
function update_ap_static_ip(_x19) {
  return _update_ap_static_ip.apply(this, arguments);
}
function _update_ap_static_ip() {
  _update_ap_static_ip = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee19(params) {
    return _regeneratorRuntime().wrap(function _callee19$(_context19) {
      while (1) switch (_context19.prev = _context19.next) {
        case 0:
          return _context19.abrupt("return", $.post("/v1/company/update_ap_static_ip/", params));
        case 1:
        case "end":
          return _context19.stop();
      }
    }, _callee19);
  }));
  return _update_ap_static_ip.apply(this, arguments);
}
function delete_ap_static_ip(_x20) {
  return _delete_ap_static_ip.apply(this, arguments);
}
function _delete_ap_static_ip() {
  _delete_ap_static_ip = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee20(params) {
    return _regeneratorRuntime().wrap(function _callee20$(_context20) {
      while (1) switch (_context20.prev = _context20.next) {
        case 0:
          return _context20.abrupt("return", $.post("/v1/company/delete_ap_static_ip/", params));
        case 1:
        case "end":
          return _context20.stop();
      }
    }, _callee20);
  }));
  return _delete_ap_static_ip.apply(this, arguments);
}
function create_cta_wifi(_x21) {
  return _create_cta_wifi.apply(this, arguments);
}
function _create_cta_wifi() {
  _create_cta_wifi = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee21(params) {
    return _regeneratorRuntime().wrap(function _callee21$(_context21) {
      while (1) switch (_context21.prev = _context21.next) {
        case 0:
          return _context21.abrupt("return", $.post("/v1/company/create_cta_wifi/", params));
        case 1:
        case "end":
          return _context21.stop();
      }
    }, _callee21);
  }));
  return _create_cta_wifi.apply(this, arguments);
}
function update_cta_wifi(_x22) {
  return _update_cta_wifi.apply(this, arguments);
}
function _update_cta_wifi() {
  _update_cta_wifi = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee22(params) {
    return _regeneratorRuntime().wrap(function _callee22$(_context22) {
      while (1) switch (_context22.prev = _context22.next) {
        case 0:
          return _context22.abrupt("return", $.post("/v1/company/update_cta_wifi/", params));
        case 1:
        case "end":
          return _context22.stop();
      }
    }, _callee22);
  }));
  return _update_cta_wifi.apply(this, arguments);
}
function delete_cta_wifi(_x23) {
  return _delete_cta_wifi.apply(this, arguments);
}
function _delete_cta_wifi() {
  _delete_cta_wifi = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee23(params) {
    return _regeneratorRuntime().wrap(function _callee23$(_context23) {
      while (1) switch (_context23.prev = _context23.next) {
        case 0:
          return _context23.abrupt("return", $.post("/v1/company/delete_cta_wifi/", params));
        case 1:
        case "end":
          return _context23.stop();
      }
    }, _callee23);
  }));
  return _delete_cta_wifi.apply(this, arguments);
}
function get_cpe_template_agency(_x24) {
  return _get_cpe_template_agency.apply(this, arguments);
}
function _get_cpe_template_agency() {
  _get_cpe_template_agency = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee24(params) {
    return _regeneratorRuntime().wrap(function _callee24$(_context24) {
      while (1) switch (_context24.prev = _context24.next) {
        case 0:
          return _context24.abrupt("return", $.getJSON("/v1/company/get_cpe_template_agency/", params));
        case 1:
        case "end":
          return _context24.stop();
      }
    }, _callee24);
  }));
  return _get_cpe_template_agency.apply(this, arguments);
}
function get_physical_ports_info(_x25) {
  return _get_physical_ports_info.apply(this, arguments);
}
function _get_physical_ports_info() {
  _get_physical_ports_info = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee25(params) {
    return _regeneratorRuntime().wrap(function _callee25$(_context25) {
      while (1) switch (_context25.prev = _context25.next) {
        case 0:
          return _context25.abrupt("return", $.getJSON("/v1/company/get_physical_ports_info/", params));
        case 1:
        case "end":
          return _context25.stop();
      }
    }, _callee25);
  }));
  return _get_physical_ports_info.apply(this, arguments);
}
function update_cpe_template_agency(_x26) {
  return _update_cpe_template_agency.apply(this, arguments);
}
function _update_cpe_template_agency() {
  _update_cpe_template_agency = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee26(params) {
    return _regeneratorRuntime().wrap(function _callee26$(_context26) {
      while (1) switch (_context26.prev = _context26.next) {
        case 0:
          return _context26.abrupt("return", $.post("/v1/company/update_cpe_template_agency/", params));
        case 1:
        case "end":
          return _context26.stop();
      }
    }, _callee26);
  }));
  return _update_cpe_template_agency.apply(this, arguments);
}
function create_cta_static_route(_x27) {
  return _create_cta_static_route.apply(this, arguments);
}
function _create_cta_static_route() {
  _create_cta_static_route = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee27(params) {
    return _regeneratorRuntime().wrap(function _callee27$(_context27) {
      while (1) switch (_context27.prev = _context27.next) {
        case 0:
          return _context27.abrupt("return", $.post("/v1/company/create_cta_static_route/", params));
        case 1:
        case "end":
          return _context27.stop();
      }
    }, _callee27);
  }));
  return _create_cta_static_route.apply(this, arguments);
}
function update_cta_static_route(_x28) {
  return _update_cta_static_route.apply(this, arguments);
}
function _update_cta_static_route() {
  _update_cta_static_route = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee28(params) {
    return _regeneratorRuntime().wrap(function _callee28$(_context28) {
      while (1) switch (_context28.prev = _context28.next) {
        case 0:
          return _context28.abrupt("return", $.post("/v1/company/update_cta_static_route/", params));
        case 1:
        case "end":
          return _context28.stop();
      }
    }, _callee28);
  }));
  return _update_cta_static_route.apply(this, arguments);
}
function delete_cta_static_route(_x29) {
  return _delete_cta_static_route.apply(this, arguments);
}
function _delete_cta_static_route() {
  _delete_cta_static_route = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee29(params) {
    return _regeneratorRuntime().wrap(function _callee29$(_context29) {
      while (1) switch (_context29.prev = _context29.next) {
        case 0:
          return _context29.abrupt("return", $.post("/v1/company/delete_cta_static_route/", params));
        case 1:
        case "end":
          return _context29.stop();
      }
    }, _callee29);
  }));
  return _delete_cta_static_route.apply(this, arguments);
}
function get_cta_static_route(_x30) {
  return _get_cta_static_route.apply(this, arguments);
}
function _get_cta_static_route() {
  _get_cta_static_route = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee30(params) {
    return _regeneratorRuntime().wrap(function _callee30$(_context30) {
      while (1) switch (_context30.prev = _context30.next) {
        case 0:
          return _context30.abrupt("return", $.getJSON("/v1/company/get_cta_static_route/", params));
        case 1:
        case "end":
          return _context30.stop();
      }
    }, _callee30);
  }));
  return _get_cta_static_route.apply(this, arguments);
}
function create_cta_static_parse(_x31) {
  return _create_cta_static_parse.apply(this, arguments);
}
function _create_cta_static_parse() {
  _create_cta_static_parse = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee31(params) {
    return _regeneratorRuntime().wrap(function _callee31$(_context31) {
      while (1) switch (_context31.prev = _context31.next) {
        case 0:
          return _context31.abrupt("return", $.post("/v1/company/create_cta_static_parse/", params));
        case 1:
        case "end":
          return _context31.stop();
      }
    }, _callee31);
  }));
  return _create_cta_static_parse.apply(this, arguments);
}
function update_cta_static_parse(_x32) {
  return _update_cta_static_parse.apply(this, arguments);
}
function _update_cta_static_parse() {
  _update_cta_static_parse = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee32(params) {
    return _regeneratorRuntime().wrap(function _callee32$(_context32) {
      while (1) switch (_context32.prev = _context32.next) {
        case 0:
          return _context32.abrupt("return", $.post("/v1/company/update_cta_static_parse/", params));
        case 1:
        case "end":
          return _context32.stop();
      }
    }, _callee32);
  }));
  return _update_cta_static_parse.apply(this, arguments);
}
function delete_cta_static_parse(_x33) {
  return _delete_cta_static_parse.apply(this, arguments);
}
function _delete_cta_static_parse() {
  _delete_cta_static_parse = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee33(params) {
    return _regeneratorRuntime().wrap(function _callee33$(_context33) {
      while (1) switch (_context33.prev = _context33.next) {
        case 0:
          return _context33.abrupt("return", $.post("/v1/company/delete_cta_static_parse/", params));
        case 1:
        case "end":
          return _context33.stop();
      }
    }, _callee33);
  }));
  return _delete_cta_static_parse.apply(this, arguments);
}
function get_cta_static_parse(_x34) {
  return _get_cta_static_parse.apply(this, arguments);
}
function _get_cta_static_parse() {
  _get_cta_static_parse = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee34(params) {
    return _regeneratorRuntime().wrap(function _callee34$(_context34) {
      while (1) switch (_context34.prev = _context34.next) {
        case 0:
          return _context34.abrupt("return", $.getJSON("/v1/company/get_cta_static_parse/", params));
        case 1:
        case "end":
          return _context34.stop();
      }
    }, _callee34);
  }));
  return _get_cta_static_parse.apply(this, arguments);
}
function get_ap_wifi(_x35) {
  return _get_ap_wifi.apply(this, arguments);
}
function _get_ap_wifi() {
  _get_ap_wifi = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee35(params) {
    return _regeneratorRuntime().wrap(function _callee35$(_context35) {
      while (1) switch (_context35.prev = _context35.next) {
        case 0:
          return _context35.abrupt("return", $.getJSON("/v1/company/get_ap_wifi/", params));
        case 1:
        case "end":
          return _context35.stop();
      }
    }, _callee35);
  }));
  return _get_ap_wifi.apply(this, arguments);
}
function get_ap_lan(_x36) {
  return _get_ap_lan.apply(this, arguments);
}
function _get_ap_lan() {
  _get_ap_lan = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee36(params) {
    return _regeneratorRuntime().wrap(function _callee36$(_context36) {
      while (1) switch (_context36.prev = _context36.next) {
        case 0:
          return _context36.abrupt("return", $.getJSON("/v1/company/get_ap_lan/", params));
        case 1:
        case "end":
          return _context36.stop();
      }
    }, _callee36);
  }));
  return _get_ap_lan.apply(this, arguments);
}
function get_ipset_by_cta_lan(_x37) {
  return _get_ipset_by_cta_lan.apply(this, arguments);
}
function _get_ipset_by_cta_lan() {
  _get_ipset_by_cta_lan = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee37(params) {
    return _regeneratorRuntime().wrap(function _callee37$(_context37) {
      while (1) switch (_context37.prev = _context37.next) {
        case 0:
          return _context37.abrupt("return", $.getJSON("/v1/company/get_ipset_by_cta_lan/", params));
        case 1:
        case "end":
          return _context37.stop();
      }
    }, _callee37);
  }));
  return _get_ipset_by_cta_lan.apply(this, arguments);
}
function update_agency(_x38) {
  return _update_agency.apply(this, arguments);
}
function _update_agency() {
  _update_agency = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee38(params) {
    return _regeneratorRuntime().wrap(function _callee38$(_context38) {
      while (1) switch (_context38.prev = _context38.next) {
        case 0:
          return _context38.abrupt("return", $.post("/v1/company/update_agency/", params));
        case 1:
        case "end":
          return _context38.stop();
      }
    }, _callee38);
  }));
  return _update_agency.apply(this, arguments);
}
function create_ap_lan(_x39) {
  return _create_ap_lan.apply(this, arguments);
}
function _create_ap_lan() {
  _create_ap_lan = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee39(params) {
    return _regeneratorRuntime().wrap(function _callee39$(_context39) {
      while (1) switch (_context39.prev = _context39.next) {
        case 0:
          return _context39.abrupt("return", $.post("/v1/company/create_ap_lan/", params));
        case 1:
        case "end":
          return _context39.stop();
      }
    }, _callee39);
  }));
  return _create_ap_lan.apply(this, arguments);
}
function update_ap_lan(_x40) {
  return _update_ap_lan.apply(this, arguments);
}
function _update_ap_lan() {
  _update_ap_lan = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee40(params) {
    return _regeneratorRuntime().wrap(function _callee40$(_context40) {
      while (1) switch (_context40.prev = _context40.next) {
        case 0:
          return _context40.abrupt("return", $.post("/v1/company/update_ap_lan/", params));
        case 1:
        case "end":
          return _context40.stop();
      }
    }, _callee40);
  }));
  return _update_ap_lan.apply(this, arguments);
}
function delete_ap_lan(_x41) {
  return _delete_ap_lan.apply(this, arguments);
}
function _delete_ap_lan() {
  _delete_ap_lan = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee41(params) {
    return _regeneratorRuntime().wrap(function _callee41$(_context41) {
      while (1) switch (_context41.prev = _context41.next) {
        case 0:
          return _context41.abrupt("return", $.post("/v1/company/delete_ap_lan/", params));
        case 1:
        case "end":
          return _context41.stop();
      }
    }, _callee41);
  }));
  return _delete_ap_lan.apply(this, arguments);
}
function create_ap_wifi(_x42) {
  return _create_ap_wifi.apply(this, arguments);
}
function _create_ap_wifi() {
  _create_ap_wifi = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee42(params) {
    return _regeneratorRuntime().wrap(function _callee42$(_context42) {
      while (1) switch (_context42.prev = _context42.next) {
        case 0:
          return _context42.abrupt("return", $.post("/v1/company/create_ap_wifi/", params));
        case 1:
        case "end":
          return _context42.stop();
      }
    }, _callee42);
  }));
  return _create_ap_wifi.apply(this, arguments);
}
function update_ap_wifi(_x43) {
  return _update_ap_wifi.apply(this, arguments);
}
function _update_ap_wifi() {
  _update_ap_wifi = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee43(params) {
    return _regeneratorRuntime().wrap(function _callee43$(_context43) {
      while (1) switch (_context43.prev = _context43.next) {
        case 0:
          return _context43.abrupt("return", $.post("/v1/company/update_ap_wifi/", params));
        case 1:
        case "end":
          return _context43.stop();
      }
    }, _callee43);
  }));
  return _update_ap_wifi.apply(this, arguments);
}
function delete_ap_wifi(_x44) {
  return _delete_ap_wifi.apply(this, arguments);
}
function _delete_ap_wifi() {
  _delete_ap_wifi = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee44(params) {
    return _regeneratorRuntime().wrap(function _callee44$(_context44) {
      while (1) switch (_context44.prev = _context44.next) {
        case 0:
          return _context44.abrupt("return", $.post("/v1/company/delete_ap_wifi/", params));
        case 1:
        case "end":
          return _context44.stop();
      }
    }, _callee44);
  }));
  return _delete_ap_wifi.apply(this, arguments);
}
function get_latest_lan_name(_x45) {
  return _get_latest_lan_name.apply(this, arguments);
}
function _get_latest_lan_name() {
  _get_latest_lan_name = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee45(params) {
    return _regeneratorRuntime().wrap(function _callee45$(_context45) {
      while (1) switch (_context45.prev = _context45.next) {
        case 0:
          return _context45.abrupt("return", $.getJSON("/v1/company/get_latest_lan_name/", params));
        case 1:
        case "end":
          return _context45.stop();
      }
    }, _callee45);
  }));
  return _get_latest_lan_name.apply(this, arguments);
}
function get_start_end_ip(_x46) {
  return _get_start_end_ip.apply(this, arguments);
}
function _get_start_end_ip() {
  _get_start_end_ip = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee46(params) {
    return _regeneratorRuntime().wrap(function _callee46$(_context46) {
      while (1) switch (_context46.prev = _context46.next) {
        case 0:
          return _context46.abrupt("return", $.getJSON("/v1/company/get_start_end_ip/", params));
        case 1:
        case "end":
          return _context46.stop();
      }
    }, _callee46);
  }));
  return _get_start_end_ip.apply(this, arguments);
}
function get_tunnel_snat(_x47) {
  return _get_tunnel_snat.apply(this, arguments);
}
function _get_tunnel_snat() {
  _get_tunnel_snat = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee47(params) {
    return _regeneratorRuntime().wrap(function _callee47$(_context47) {
      while (1) switch (_context47.prev = _context47.next) {
        case 0:
          return _context47.abrupt("return", $.getJSON("/v1/company/get_tunnel_snat/", params));
        case 1:
        case "end":
          return _context47.stop();
      }
    }, _callee47);
  }));
  return _get_tunnel_snat.apply(this, arguments);
}
function create_tunnel_snat(_x48) {
  return _create_tunnel_snat.apply(this, arguments);
}
function _create_tunnel_snat() {
  _create_tunnel_snat = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee48(params) {
    return _regeneratorRuntime().wrap(function _callee48$(_context48) {
      while (1) switch (_context48.prev = _context48.next) {
        case 0:
          return _context48.abrupt("return", $.post("/v1/company/create_tunnel_snat/", params));
        case 1:
        case "end":
          return _context48.stop();
      }
    }, _callee48);
  }));
  return _create_tunnel_snat.apply(this, arguments);
}
function delete_tunnel_snat(_x49) {
  return _delete_tunnel_snat.apply(this, arguments);
}
function _delete_tunnel_snat() {
  _delete_tunnel_snat = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee49(params) {
    return _regeneratorRuntime().wrap(function _callee49$(_context49) {
      while (1) switch (_context49.prev = _context49.next) {
        case 0:
          return _context49.abrupt("return", $.post("/v1/company/delete_tunnel_snat/", params));
        case 1:
        case "end":
          return _context49.stop();
      }
    }, _callee49);
  }));
  return _delete_tunnel_snat.apply(this, arguments);
}
function update_tunnel_snat(_x50) {
  return _update_tunnel_snat.apply(this, arguments);
}
function _update_tunnel_snat() {
  _update_tunnel_snat = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee50(params) {
    return _regeneratorRuntime().wrap(function _callee50$(_context50) {
      while (1) switch (_context50.prev = _context50.next) {
        case 0:
          return _context50.abrupt("return", $.post("/v1/company/update_tunnel_snat/", params));
        case 1:
        case "end":
          return _context50.stop();
      }
    }, _callee50);
  }));
  return _update_tunnel_snat.apply(this, arguments);
}
function get_tunnel_dnat(_x51) {
  return _get_tunnel_dnat.apply(this, arguments);
}
function _get_tunnel_dnat() {
  _get_tunnel_dnat = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee51(params) {
    return _regeneratorRuntime().wrap(function _callee51$(_context51) {
      while (1) switch (_context51.prev = _context51.next) {
        case 0:
          return _context51.abrupt("return", $.getJSON("/v1/company/get_tunnel_dnat/", params));
        case 1:
        case "end":
          return _context51.stop();
      }
    }, _callee51);
  }));
  return _get_tunnel_dnat.apply(this, arguments);
}
function create_tunnel_dnat(_x52) {
  return _create_tunnel_dnat.apply(this, arguments);
}
function _create_tunnel_dnat() {
  _create_tunnel_dnat = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee52(params) {
    return _regeneratorRuntime().wrap(function _callee52$(_context52) {
      while (1) switch (_context52.prev = _context52.next) {
        case 0:
          return _context52.abrupt("return", $.post("/v1/company/create_tunnel_dnat/", params));
        case 1:
        case "end":
          return _context52.stop();
      }
    }, _callee52);
  }));
  return _create_tunnel_dnat.apply(this, arguments);
}
function delete_tunnel_dnat(_x53) {
  return _delete_tunnel_dnat.apply(this, arguments);
}
function _delete_tunnel_dnat() {
  _delete_tunnel_dnat = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee53(params) {
    return _regeneratorRuntime().wrap(function _callee53$(_context53) {
      while (1) switch (_context53.prev = _context53.next) {
        case 0:
          return _context53.abrupt("return", $.post("/v1/company/delete_tunnel_dnat/", params));
        case 1:
        case "end":
          return _context53.stop();
      }
    }, _callee53);
  }));
  return _delete_tunnel_dnat.apply(this, arguments);
}
function update_tunnel_dnat(_x54) {
  return _update_tunnel_dnat.apply(this, arguments);
}
function _update_tunnel_dnat() {
  _update_tunnel_dnat = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee54(params) {
    return _regeneratorRuntime().wrap(function _callee54$(_context54) {
      while (1) switch (_context54.prev = _context54.next) {
        case 0:
          return _context54.abrupt("return", $.post("/v1/company/update_tunnel_dnat/", params));
        case 1:
        case "end":
          return _context54.stop();
      }
    }, _callee54);
  }));
  return _update_tunnel_dnat.apply(this, arguments);
}
function get_available_ports_for_vlan(_x55) {
  return _get_available_ports_for_vlan.apply(this, arguments);
}
function _get_available_ports_for_vlan() {
  _get_available_ports_for_vlan = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee55(params) {
    return _regeneratorRuntime().wrap(function _callee55$(_context55) {
      while (1) switch (_context55.prev = _context55.next) {
        case 0:
          return _context55.abrupt("return", $.getJSON("/v1/company/get_available_ports_for_vlan/", params));
        case 1:
        case "end":
          return _context55.stop();
      }
    }, _callee55);
  }));
  return _get_available_ports_for_vlan.apply(this, arguments);
}
function get_cta_vlan(_x56) {
  return _get_cta_vlan.apply(this, arguments);
}
function _get_cta_vlan() {
  _get_cta_vlan = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee56(params) {
    return _regeneratorRuntime().wrap(function _callee56$(_context56) {
      while (1) switch (_context56.prev = _context56.next) {
        case 0:
          return _context56.abrupt("return", $.getJSON("/v1/company/get_cta_vlan/", params));
        case 1:
        case "end":
          return _context56.stop();
      }
    }, _callee56);
  }));
  return _get_cta_vlan.apply(this, arguments);
}
function create_cta_vlan(_x57) {
  return _create_cta_vlan.apply(this, arguments);
}
function _create_cta_vlan() {
  _create_cta_vlan = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee57(params) {
    return _regeneratorRuntime().wrap(function _callee57$(_context57) {
      while (1) switch (_context57.prev = _context57.next) {
        case 0:
          return _context57.abrupt("return", $.post("/v1/company/create_cta_vlan/", params));
        case 1:
        case "end":
          return _context57.stop();
      }
    }, _callee57);
  }));
  return _create_cta_vlan.apply(this, arguments);
}
function update_cta_vlan(_x58) {
  return _update_cta_vlan.apply(this, arguments);
}
function _update_cta_vlan() {
  _update_cta_vlan = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee58(params) {
    return _regeneratorRuntime().wrap(function _callee58$(_context58) {
      while (1) switch (_context58.prev = _context58.next) {
        case 0:
          return _context58.abrupt("return", $.post("/v1/company/update_cta_vlan/", params));
        case 1:
        case "end":
          return _context58.stop();
      }
    }, _callee58);
  }));
  return _update_cta_vlan.apply(this, arguments);
}
function delete_cta_vlan(_x59) {
  return _delete_cta_vlan.apply(this, arguments);
}
function _delete_cta_vlan() {
  _delete_cta_vlan = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee59(params) {
    return _regeneratorRuntime().wrap(function _callee59$(_context59) {
      while (1) switch (_context59.prev = _context59.next) {
        case 0:
          return _context59.abrupt("return", $.post("/v1/company/delete_cta_vlan/", params));
        case 1:
        case "end":
          return _context59.stop();
      }
    }, _callee59);
  }));
  return _delete_cta_vlan.apply(this, arguments);
}
function get_cta_dnat(_x60) {
  return _get_cta_dnat.apply(this, arguments);
}
function _get_cta_dnat() {
  _get_cta_dnat = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee60(params) {
    return _regeneratorRuntime().wrap(function _callee60$(_context60) {
      while (1) switch (_context60.prev = _context60.next) {
        case 0:
          return _context60.abrupt("return", $.getJSON("/v1/company/get_cta_dnat/", params));
        case 1:
        case "end":
          return _context60.stop();
      }
    }, _callee60);
  }));
  return _get_cta_dnat.apply(this, arguments);
}
function create_cta_dnat(_x61) {
  return _create_cta_dnat.apply(this, arguments);
}
function _create_cta_dnat() {
  _create_cta_dnat = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee61(params) {
    return _regeneratorRuntime().wrap(function _callee61$(_context61) {
      while (1) switch (_context61.prev = _context61.next) {
        case 0:
          return _context61.abrupt("return", $.post("/v1/company/create_cta_dnat/", params));
        case 1:
        case "end":
          return _context61.stop();
      }
    }, _callee61);
  }));
  return _create_cta_dnat.apply(this, arguments);
}
function update_cta_dnat(_x62) {
  return _update_cta_dnat.apply(this, arguments);
}
function _update_cta_dnat() {
  _update_cta_dnat = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee62(params) {
    return _regeneratorRuntime().wrap(function _callee62$(_context62) {
      while (1) switch (_context62.prev = _context62.next) {
        case 0:
          return _context62.abrupt("return", $.post("/v1/company/update_cta_dnat/", params));
        case 1:
        case "end":
          return _context62.stop();
      }
    }, _callee62);
  }));
  return _update_cta_dnat.apply(this, arguments);
}
function delete_cta_dnat(_x63) {
  return _delete_cta_dnat.apply(this, arguments);
}
function _delete_cta_dnat() {
  _delete_cta_dnat = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee63(params) {
    return _regeneratorRuntime().wrap(function _callee63$(_context63) {
      while (1) switch (_context63.prev = _context63.next) {
        case 0:
          return _context63.abrupt("return", $.post("/v1/company/delete_cta_dnat/", params));
        case 1:
        case "end":
          return _context63.stop();
      }
    }, _callee63);
  }));
  return _delete_cta_dnat.apply(this, arguments);
}
function get_crash(_x64) {
  return _get_crash.apply(this, arguments);
}
function _get_crash() {
  _get_crash = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee64(params) {
    return _regeneratorRuntime().wrap(function _callee64$(_context64) {
      while (1) switch (_context64.prev = _context64.next) {
        case 0:
          return _context64.abrupt("return", $.getJSON("/v1/rate/get_crash/", params));
        case 1:
        case "end":
          return _context64.stop();
      }
    }, _callee64);
  }));
  return _get_crash.apply(this, arguments);
}
function create_multi_dns(_x65) {
  return _create_multi_dns.apply(this, arguments);
}
function _create_multi_dns() {
  _create_multi_dns = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee65(params) {
    return _regeneratorRuntime().wrap(function _callee65$(_context65) {
      while (1) switch (_context65.prev = _context65.next) {
        case 0:
          return _context65.abrupt("return", $.post("/v1/company/create_multi_dns/", params));
        case 1:
        case "end":
          return _context65.stop();
      }
    }, _callee65);
  }));
  return _create_multi_dns.apply(this, arguments);
}
function update_multi_dns(_x66) {
  return _update_multi_dns.apply(this, arguments);
}
function _update_multi_dns() {
  _update_multi_dns = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee66(params) {
    return _regeneratorRuntime().wrap(function _callee66$(_context66) {
      while (1) switch (_context66.prev = _context66.next) {
        case 0:
          return _context66.abrupt("return", $.post("/v1/company/update_multi_dns/", params));
        case 1:
        case "end":
          return _context66.stop();
      }
    }, _callee66);
  }));
  return _update_multi_dns.apply(this, arguments);
}
function delete_multi_dns(_x67) {
  return _delete_multi_dns.apply(this, arguments);
}
function _delete_multi_dns() {
  _delete_multi_dns = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee67(params) {
    return _regeneratorRuntime().wrap(function _callee67$(_context67) {
      while (1) switch (_context67.prev = _context67.next) {
        case 0:
          return _context67.abrupt("return", $.post("/v1/company/delete_multi_dns/", params));
        case 1:
        case "end":
          return _context67.stop();
      }
    }, _callee67);
  }));
  return _delete_multi_dns.apply(this, arguments);
}
function get_multi_dns(_x68) {
  return _get_multi_dns.apply(this, arguments);
}
function _get_multi_dns() {
  _get_multi_dns = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee68(params) {
    return _regeneratorRuntime().wrap(function _callee68$(_context68) {
      while (1) switch (_context68.prev = _context68.next) {
        case 0:
          return _context68.abrupt("return", $.getJSON("/v1/company/get_multi_dns/", params));
        case 1:
        case "end":
          return _context68.stop();
      }
    }, _callee68);
  }));
  return _get_multi_dns.apply(this, arguments);
}
function get_step_userinfo(_x69) {
  return _get_step_userinfo.apply(this, arguments);
}
function _get_step_userinfo() {
  _get_step_userinfo = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee69(params) {
    return _regeneratorRuntime().wrap(function _callee69$(_context69) {
      while (1) switch (_context69.prev = _context69.next) {
        case 0:
          return _context69.abrupt("return", $.getJSON("/v1/rate/get_step_userinfo/", params));
        case 1:
        case "end":
          return _context69.stop();
      }
    }, _callee69);
  }));
  return _get_step_userinfo.apply(this, arguments);
}
function get_centre_agency_detail(_x70) {
  return _get_centre_agency_detail.apply(this, arguments);
}
function _get_centre_agency_detail() {
  _get_centre_agency_detail = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee70(params) {
    return _regeneratorRuntime().wrap(function _callee70$(_context70) {
      while (1) switch (_context70.prev = _context70.next) {
        case 0:
          return _context70.abrupt("return", $.getJSON("/v1/company/get_centre_agency_detail/", params));
        case 1:
        case "end":
          return _context70.stop();
      }
    }, _callee70);
  }));
  return _get_centre_agency_detail.apply(this, arguments);
}
function create_vyos_lan(_x71) {
  return _create_vyos_lan.apply(this, arguments);
}
function _create_vyos_lan() {
  _create_vyos_lan = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee71(params) {
    return _regeneratorRuntime().wrap(function _callee71$(_context71) {
      while (1) switch (_context71.prev = _context71.next) {
        case 0:
          return _context71.abrupt("return", $.post("/v1/company/vyos/create_vyos_lan/", params));
        case 1:
        case "end":
          return _context71.stop();
      }
    }, _callee71);
  }));
  return _create_vyos_lan.apply(this, arguments);
}
function update_vyos_lan(_x72) {
  return _update_vyos_lan.apply(this, arguments);
}
function _update_vyos_lan() {
  _update_vyos_lan = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee72(params) {
    return _regeneratorRuntime().wrap(function _callee72$(_context72) {
      while (1) switch (_context72.prev = _context72.next) {
        case 0:
          return _context72.abrupt("return", $.post("/v1/company/vyos/update_vyos_lan/", params));
        case 1:
        case "end":
          return _context72.stop();
      }
    }, _callee72);
  }));
  return _update_vyos_lan.apply(this, arguments);
}
function delete_vyos_lan(_x73) {
  return _delete_vyos_lan.apply(this, arguments);
}
function _delete_vyos_lan() {
  _delete_vyos_lan = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee73(params) {
    return _regeneratorRuntime().wrap(function _callee73$(_context73) {
      while (1) switch (_context73.prev = _context73.next) {
        case 0:
          return _context73.abrupt("return", $.post("/v1/company/vyos/delete_vyos_lan/", params));
        case 1:
        case "end":
          return _context73.stop();
      }
    }, _callee73);
  }));
  return _delete_vyos_lan.apply(this, arguments);
}
function get_vyos_lan(_x74) {
  return _get_vyos_lan.apply(this, arguments);
}
function _get_vyos_lan() {
  _get_vyos_lan = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee74(params) {
    return _regeneratorRuntime().wrap(function _callee74$(_context74) {
      while (1) switch (_context74.prev = _context74.next) {
        case 0:
          return _context74.abrupt("return", $.getJSON("/v1/company/vyos/get_vyos_lan/", params));
        case 1:
        case "end":
          return _context74.stop();
      }
    }, _callee74);
  }));
  return _get_vyos_lan.apply(this, arguments);
}
function bind_vyos_dhcp(_x75) {
  return _bind_vyos_dhcp.apply(this, arguments);
}
function _bind_vyos_dhcp() {
  _bind_vyos_dhcp = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee75(params) {
    return _regeneratorRuntime().wrap(function _callee75$(_context75) {
      while (1) switch (_context75.prev = _context75.next) {
        case 0:
          return _context75.abrupt("return", $.post("/v1/company/vyos/bind_vyos_dhcp/", params));
        case 1:
        case "end":
          return _context75.stop();
      }
    }, _callee75);
  }));
  return _bind_vyos_dhcp.apply(this, arguments);
}
function create_vyos_vlan(_x76) {
  return _create_vyos_vlan.apply(this, arguments);
}
function _create_vyos_vlan() {
  _create_vyos_vlan = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee76(params) {
    return _regeneratorRuntime().wrap(function _callee76$(_context76) {
      while (1) switch (_context76.prev = _context76.next) {
        case 0:
          return _context76.abrupt("return", $.post("/v1/company/vyos/create_vyos_vlan/", params));
        case 1:
        case "end":
          return _context76.stop();
      }
    }, _callee76);
  }));
  return _create_vyos_vlan.apply(this, arguments);
}
function update_vyos_vlan(_x77) {
  return _update_vyos_vlan.apply(this, arguments);
}
function _update_vyos_vlan() {
  _update_vyos_vlan = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee77(params) {
    return _regeneratorRuntime().wrap(function _callee77$(_context77) {
      while (1) switch (_context77.prev = _context77.next) {
        case 0:
          return _context77.abrupt("return", $.post("/v1/company/vyos/update_vyos_vlan/", params));
        case 1:
        case "end":
          return _context77.stop();
      }
    }, _callee77);
  }));
  return _update_vyos_vlan.apply(this, arguments);
}
function delete_vyos_vlan(_x78) {
  return _delete_vyos_vlan.apply(this, arguments);
}
function _delete_vyos_vlan() {
  _delete_vyos_vlan = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee78(params) {
    return _regeneratorRuntime().wrap(function _callee78$(_context78) {
      while (1) switch (_context78.prev = _context78.next) {
        case 0:
          return _context78.abrupt("return", $.post("/v1/company/vyos/delete_vyos_vlan/", params));
        case 1:
        case "end":
          return _context78.stop();
      }
    }, _callee78);
  }));
  return _delete_vyos_vlan.apply(this, arguments);
}
function bind_wan_firewall(_x79) {
  return _bind_wan_firewall.apply(this, arguments);
}
function _bind_wan_firewall() {
  _bind_wan_firewall = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee79(params) {
    return _regeneratorRuntime().wrap(function _callee79$(_context79) {
      while (1) switch (_context79.prev = _context79.next) {
        case 0:
          return _context79.abrupt("return", $.post("/v1/company/vyos/bind_wan_firewall/", params));
        case 1:
        case "end":
          return _context79.stop();
      }
    }, _callee79);
  }));
  return _bind_wan_firewall.apply(this, arguments);
}
function bind_redirect_ip(_x80) {
  return _bind_redirect_ip.apply(this, arguments);
}
function _bind_redirect_ip() {
  _bind_redirect_ip = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee80(params) {
    return _regeneratorRuntime().wrap(function _callee80$(_context80) {
      while (1) switch (_context80.prev = _context80.next) {
        case 0:
          return _context80.abrupt("return", $.post("/v1/company/vyos/bind_redirect_ip/", params));
        case 1:
        case "end":
          return _context80.stop();
      }
    }, _callee80);
  }));
  return _bind_redirect_ip.apply(this, arguments);
}
function bind_wan_snat(_x81) {
  return _bind_wan_snat.apply(this, arguments);
}
function _bind_wan_snat() {
  _bind_wan_snat = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee81(params) {
    return _regeneratorRuntime().wrap(function _callee81$(_context81) {
      while (1) switch (_context81.prev = _context81.next) {
        case 0:
          return _context81.abrupt("return", $.post("/v1/company/vyos/bind_wan_snat/", params));
        case 1:
        case "end":
          return _context81.stop();
      }
    }, _callee81);
  }));
  return _bind_wan_snat.apply(this, arguments);
}
function bind_wan_dns_interception(_x82) {
  return _bind_wan_dns_interception.apply(this, arguments);
}
function _bind_wan_dns_interception() {
  _bind_wan_dns_interception = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee82(params) {
    return _regeneratorRuntime().wrap(function _callee82$(_context82) {
      while (1) switch (_context82.prev = _context82.next) {
        case 0:
          return _context82.abrupt("return", $.post("/v1/company/vyos/bind_wan_dns_interception/", params));
        case 1:
        case "end":
          return _context82.stop();
      }
    }, _callee82);
  }));
  return _bind_wan_dns_interception.apply(this, arguments);
}
function get_policy_number_range(_x83) {
  return _get_policy_number_range.apply(this, arguments);
}
function _get_policy_number_range() {
  _get_policy_number_range = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee83(params) {
    return _regeneratorRuntime().wrap(function _callee83$(_context83) {
      while (1) switch (_context83.prev = _context83.next) {
        case 0:
          return _context83.abrupt("return", $.getJSON("/v1/company/vyos/get_policy_number_range/", params));
        case 1:
        case "end":
          return _context83.stop();
      }
    }, _callee83);
  }));
  return _get_policy_number_range.apply(this, arguments);
}
function bind_tunnel_flow(_x84) {
  return _bind_tunnel_flow.apply(this, arguments);
}
function _bind_tunnel_flow() {
  _bind_tunnel_flow = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee84(params) {
    return _regeneratorRuntime().wrap(function _callee84$(_context84) {
      while (1) switch (_context84.prev = _context84.next) {
        case 0:
          return _context84.abrupt("return", $.post("/v1/company/vyos/bind_tunnel_flow/", params));
        case 1:
        case "end":
          return _context84.stop();
      }
    }, _callee84);
  }));
  return _bind_tunnel_flow.apply(this, arguments);
}
function create_vyos_wan(_x85) {
  return _create_vyos_wan.apply(this, arguments);
}
function _create_vyos_wan() {
  _create_vyos_wan = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee85(params) {
    return _regeneratorRuntime().wrap(function _callee85$(_context85) {
      while (1) switch (_context85.prev = _context85.next) {
        case 0:
          return _context85.abrupt("return", $.post("/v1/company/vyos/create_vyos_wan/", params));
        case 1:
        case "end":
          return _context85.stop();
      }
    }, _callee85);
  }));
  return _create_vyos_wan.apply(this, arguments);
}
function update_vyos_wan(_x86) {
  return _update_vyos_wan.apply(this, arguments);
}
function _update_vyos_wan() {
  _update_vyos_wan = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee86(params) {
    return _regeneratorRuntime().wrap(function _callee86$(_context86) {
      while (1) switch (_context86.prev = _context86.next) {
        case 0:
          return _context86.abrupt("return", $.post("/v1/company/vyos/update_vyos_wan/", params));
        case 1:
        case "end":
          return _context86.stop();
      }
    }, _callee86);
  }));
  return _update_vyos_wan.apply(this, arguments);
}
function delete_vyos_wan(_x87) {
  return _delete_vyos_wan.apply(this, arguments);
}
function _delete_vyos_wan() {
  _delete_vyos_wan = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee87(params) {
    return _regeneratorRuntime().wrap(function _callee87$(_context87) {
      while (1) switch (_context87.prev = _context87.next) {
        case 0:
          return _context87.abrupt("return", $.deleteObj("/v1/company/vyos/delete_vyos_wan/", params));
        case 1:
        case "end":
          return _context87.stop();
      }
    }, _callee87);
  }));
  return _delete_vyos_wan.apply(this, arguments);
}
function get_vyos_wan(_x88) {
  return _get_vyos_wan.apply(this, arguments);
}
function _get_vyos_wan() {
  _get_vyos_wan = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee88(params) {
    return _regeneratorRuntime().wrap(function _callee88$(_context88) {
      while (1) switch (_context88.prev = _context88.next) {
        case 0:
          return _context88.abrupt("return", $.getJSON("/v1/company/vyos/get_vyos_wan/", params));
        case 1:
        case "end":
          return _context88.stop();
      }
    }, _callee88);
  }));
  return _get_vyos_wan.apply(this, arguments);
}
function get_available_ports(_x89) {
  return _get_available_ports.apply(this, arguments);
}
function _get_available_ports() {
  _get_available_ports = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee89(params) {
    return _regeneratorRuntime().wrap(function _callee89$(_context89) {
      while (1) switch (_context89.prev = _context89.next) {
        case 0:
          return _context89.abrupt("return", $.getJSON("/v1/company/vyos/get_available_ports/", params));
        case 1:
        case "end":
          return _context89.stop();
      }
    }, _callee89);
  }));
  return _get_available_ports.apply(this, arguments);
}
function get_interface_alias(_x90) {
  return _get_interface_alias.apply(this, arguments);
}
function _get_interface_alias() {
  _get_interface_alias = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee90(params) {
    return _regeneratorRuntime().wrap(function _callee90$(_context90) {
      while (1) switch (_context90.prev = _context90.next) {
        case 0:
          return _context90.abrupt("return", $.getJSON("/v1/company/vyos/get_interface_alias/", params));
        case 1:
        case "end":
          return _context90.stop();
      }
    }, _callee90);
  }));
  return _get_interface_alias.apply(this, arguments);
}
function get_vyos_physical_ports_info(_x91) {
  return _get_vyos_physical_ports_info.apply(this, arguments);
}
function _get_vyos_physical_ports_info() {
  _get_vyos_physical_ports_info = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee91(params) {
    return _regeneratorRuntime().wrap(function _callee91$(_context91) {
      while (1) switch (_context91.prev = _context91.next) {
        case 0:
          return _context91.abrupt("return", $.getJSON("/v1/company/vyos/get_vyos_physical_ports_info/", params));
        case 1:
        case "end":
          return _context91.stop();
      }
    }, _callee91);
  }));
  return _get_vyos_physical_ports_info.apply(this, arguments);
}
function get_vyos_static_route(_x92) {
  return _get_vyos_static_route.apply(this, arguments);
}
function _get_vyos_static_route() {
  _get_vyos_static_route = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee92(params) {
    return _regeneratorRuntime().wrap(function _callee92$(_context92) {
      while (1) switch (_context92.prev = _context92.next) {
        case 0:
          return _context92.abrupt("return", $.getJSON("/v1/company/vyos/get_vyos_static_route/", params));
        case 1:
        case "end":
          return _context92.stop();
      }
    }, _callee92);
  }));
  return _get_vyos_static_route.apply(this, arguments);
}
function create_vyos_static_route(_x93) {
  return _create_vyos_static_route.apply(this, arguments);
}
function _create_vyos_static_route() {
  _create_vyos_static_route = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee93(params) {
    return _regeneratorRuntime().wrap(function _callee93$(_context93) {
      while (1) switch (_context93.prev = _context93.next) {
        case 0:
          return _context93.abrupt("return", $.post("/v1/company/vyos/create_vyos_static_route/", params));
        case 1:
        case "end":
          return _context93.stop();
      }
    }, _callee93);
  }));
  return _create_vyos_static_route.apply(this, arguments);
}
function update_vyos_static_route(_x94) {
  return _update_vyos_static_route.apply(this, arguments);
}
function _update_vyos_static_route() {
  _update_vyos_static_route = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee94(params) {
    return _regeneratorRuntime().wrap(function _callee94$(_context94) {
      while (1) switch (_context94.prev = _context94.next) {
        case 0:
          return _context94.abrupt("return", $.post("/v1/company/vyos/update_vyos_static_route/", params));
        case 1:
        case "end":
          return _context94.stop();
      }
    }, _callee94);
  }));
  return _update_vyos_static_route.apply(this, arguments);
}
function delete_vyos_static_route(_x95) {
  return _delete_vyos_static_route.apply(this, arguments);
}
function _delete_vyos_static_route() {
  _delete_vyos_static_route = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee95(params) {
    return _regeneratorRuntime().wrap(function _callee95$(_context95) {
      while (1) switch (_context95.prev = _context95.next) {
        case 0:
          return _context95.abrupt("return", $.deleteObj("/v1/company/vyos/delete_vyos_static_route/", params));
        case 1:
        case "end":
          return _context95.stop();
      }
    }, _callee95);
  }));
  return _delete_vyos_static_route.apply(this, arguments);
}
function get_vyos_vlan(_x96) {
  return _get_vyos_vlan.apply(this, arguments);
}
function _get_vyos_vlan() {
  _get_vyos_vlan = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee96(params) {
    return _regeneratorRuntime().wrap(function _callee96$(_context96) {
      while (1) switch (_context96.prev = _context96.next) {
        case 0:
          return _context96.abrupt("return", $.getJSON("/v1/company/vyos/get_vyos_vlan/", params));
        case 1:
        case "end":
          return _context96.stop();
      }
    }, _callee96);
  }));
  return _get_vyos_vlan.apply(this, arguments);
}
function get_bgp(_x97) {
  return _get_bgp.apply(this, arguments);
}
function _get_bgp() {
  _get_bgp = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee97(params) {
    return _regeneratorRuntime().wrap(function _callee97$(_context97) {
      while (1) switch (_context97.prev = _context97.next) {
        case 0:
          return _context97.abrupt("return", $.getJSON("/v1/company/vyos/get_bgp/", params));
        case 1:
        case "end":
          return _context97.stop();
      }
    }, _callee97);
  }));
  return _get_bgp.apply(this, arguments);
}
function create_bgp(_x98) {
  return _create_bgp.apply(this, arguments);
}
function _create_bgp() {
  _create_bgp = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee98(params) {
    return _regeneratorRuntime().wrap(function _callee98$(_context98) {
      while (1) switch (_context98.prev = _context98.next) {
        case 0:
          return _context98.abrupt("return", $.post("/v1/company/vyos/create_bgp/", params));
        case 1:
        case "end":
          return _context98.stop();
      }
    }, _callee98);
  }));
  return _create_bgp.apply(this, arguments);
}
function query_bgp_neighbor_list(_x99) {
  return _query_bgp_neighbor_list.apply(this, arguments);
}
function _query_bgp_neighbor_list() {
  _query_bgp_neighbor_list = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee99(params) {
    return _regeneratorRuntime().wrap(function _callee99$(_context99) {
      while (1) switch (_context99.prev = _context99.next) {
        case 0:
          return _context99.abrupt("return", $.getJSON("/v1/company/vyos/query_bgp_neighbor_list/", params));
        case 1:
        case "end":
          return _context99.stop();
      }
    }, _callee99);
  }));
  return _query_bgp_neighbor_list.apply(this, arguments);
}
function create_bgp_neighbor(_x100) {
  return _create_bgp_neighbor.apply(this, arguments);
}
function _create_bgp_neighbor() {
  _create_bgp_neighbor = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee100(params) {
    return _regeneratorRuntime().wrap(function _callee100$(_context100) {
      while (1) switch (_context100.prev = _context100.next) {
        case 0:
          return _context100.abrupt("return", $.post("/v1/company/vyos/create_bgp_neighbor/", params));
        case 1:
        case "end":
          return _context100.stop();
      }
    }, _callee100);
  }));
  return _create_bgp_neighbor.apply(this, arguments);
}
function update_bgp_neighbor(_x101) {
  return _update_bgp_neighbor.apply(this, arguments);
}
function _update_bgp_neighbor() {
  _update_bgp_neighbor = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee101(params) {
    return _regeneratorRuntime().wrap(function _callee101$(_context101) {
      while (1) switch (_context101.prev = _context101.next) {
        case 0:
          return _context101.abrupt("return", $.post("/v1/company/vyos/update_bgp_neighbor/", params));
        case 1:
        case "end":
          return _context101.stop();
      }
    }, _callee101);
  }));
  return _update_bgp_neighbor.apply(this, arguments);
}
function delete_bgp_neighbor(_x102) {
  return _delete_bgp_neighbor.apply(this, arguments);
}
function _delete_bgp_neighbor() {
  _delete_bgp_neighbor = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee102(params) {
    return _regeneratorRuntime().wrap(function _callee102$(_context102) {
      while (1) switch (_context102.prev = _context102.next) {
        case 0:
          return _context102.abrupt("return", $.post("/v1/company/vyos/delete_bgp_neighbor/", params));
        case 1:
        case "end":
          return _context102.stop();
      }
    }, _callee102);
  }));
  return _delete_bgp_neighbor.apply(this, arguments);
}
function update_ospf(_x103) {
  return _update_ospf.apply(this, arguments);
}
function _update_ospf() {
  _update_ospf = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee103(params) {
    return _regeneratorRuntime().wrap(function _callee103$(_context103) {
      while (1) switch (_context103.prev = _context103.next) {
        case 0:
          return _context103.abrupt("return", $.post("/v1/company/vyos/update_ospf/", params));
        case 1:
        case "end":
          return _context103.stop();
      }
    }, _callee103);
  }));
  return _update_ospf.apply(this, arguments);
}
function query_ospf_area_list(_x104) {
  return _query_ospf_area_list.apply(this, arguments);
}
function _query_ospf_area_list() {
  _query_ospf_area_list = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee104(params) {
    return _regeneratorRuntime().wrap(function _callee104$(_context104) {
      while (1) switch (_context104.prev = _context104.next) {
        case 0:
          return _context104.abrupt("return", $.getJSON("/v1/company/vyos/query_ospf_area_list/", params));
        case 1:
        case "end":
          return _context104.stop();
      }
    }, _callee104);
  }));
  return _query_ospf_area_list.apply(this, arguments);
}
function create_ospf_area(_x105) {
  return _create_ospf_area.apply(this, arguments);
}
function _create_ospf_area() {
  _create_ospf_area = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee105(params) {
    return _regeneratorRuntime().wrap(function _callee105$(_context105) {
      while (1) switch (_context105.prev = _context105.next) {
        case 0:
          return _context105.abrupt("return", $.post("/v1/company/vyos/create_ospf_area/", params));
        case 1:
        case "end":
          return _context105.stop();
      }
    }, _callee105);
  }));
  return _create_ospf_area.apply(this, arguments);
}
function update_ospf_area(_x106) {
  return _update_ospf_area.apply(this, arguments);
}
function _update_ospf_area() {
  _update_ospf_area = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee106(params) {
    return _regeneratorRuntime().wrap(function _callee106$(_context106) {
      while (1) switch (_context106.prev = _context106.next) {
        case 0:
          return _context106.abrupt("return", $.put("/v1/company/vyos/update_ospf_area/", params));
        case 1:
        case "end":
          return _context106.stop();
      }
    }, _callee106);
  }));
  return _update_ospf_area.apply(this, arguments);
}
function delete_ospf_area(_x107) {
  return _delete_ospf_area.apply(this, arguments);
}
function _delete_ospf_area() {
  _delete_ospf_area = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee107(params) {
    return _regeneratorRuntime().wrap(function _callee107$(_context107) {
      while (1) switch (_context107.prev = _context107.next) {
        case 0:
          return _context107.abrupt("return", $.post("/v1/company/vyos/delete_ospf_area/", params));
        case 1:
        case "end":
          return _context107.stop();
      }
    }, _callee107);
  }));
  return _delete_ospf_area.apply(this, arguments);
}
function create_ospf_area_network(_x108) {
  return _create_ospf_area_network.apply(this, arguments);
}
function _create_ospf_area_network() {
  _create_ospf_area_network = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee108(params) {
    return _regeneratorRuntime().wrap(function _callee108$(_context108) {
      while (1) switch (_context108.prev = _context108.next) {
        case 0:
          return _context108.abrupt("return", $.post("/v1/company/vyos/create_ospf_area_network/", params));
        case 1:
        case "end":
          return _context108.stop();
      }
    }, _callee108);
  }));
  return _create_ospf_area_network.apply(this, arguments);
}
function query_ospf_area_network(_x109) {
  return _query_ospf_area_network.apply(this, arguments);
}
function _query_ospf_area_network() {
  _query_ospf_area_network = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee109(params) {
    return _regeneratorRuntime().wrap(function _callee109$(_context109) {
      while (1) switch (_context109.prev = _context109.next) {
        case 0:
          return _context109.abrupt("return", $.getJSON("/v1/company/vyos/query_ospf_area_network/", params));
        case 1:
        case "end":
          return _context109.stop();
      }
    }, _callee109);
  }));
  return _query_ospf_area_network.apply(this, arguments);
}
function delete_ospf_area_network(_x110) {
  return _delete_ospf_area_network.apply(this, arguments);
}
function _delete_ospf_area_network() {
  _delete_ospf_area_network = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee110(params) {
    return _regeneratorRuntime().wrap(function _callee110$(_context110) {
      while (1) switch (_context110.prev = _context110.next) {
        case 0:
          return _context110.abrupt("return", $.post("/v1/company/vyos/delete_ospf_area_network/", params));
        case 1:
        case "end":
          return _context110.stop();
      }
    }, _callee110);
  }));
  return _delete_ospf_area_network.apply(this, arguments);
}
function update_ospf_area_network(_x111) {
  return _update_ospf_area_network.apply(this, arguments);
}
function _update_ospf_area_network() {
  _update_ospf_area_network = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee111(params) {
    return _regeneratorRuntime().wrap(function _callee111$(_context111) {
      while (1) switch (_context111.prev = _context111.next) {
        case 0:
          return _context111.abrupt("return", $.post("/v1/company/vyos/update_ospf_area_network/", params));
        case 1:
        case "end":
          return _context111.stop();
      }
    }, _callee111);
  }));
  return _update_ospf_area_network.apply(this, arguments);
}
function query_pbr_list(_x112) {
  return _query_pbr_list.apply(this, arguments);
}
function _query_pbr_list() {
  _query_pbr_list = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee112(params) {
    return _regeneratorRuntime().wrap(function _callee112$(_context112) {
      while (1) switch (_context112.prev = _context112.next) {
        case 0:
          return _context112.abrupt("return", $.getJSON("/v1/company/vyos/query_pbr_list/", params));
        case 1:
        case "end":
          return _context112.stop();
      }
    }, _callee112);
  }));
  return _query_pbr_list.apply(this, arguments);
}
function create_pbr(_x113) {
  return _create_pbr.apply(this, arguments);
}
function _create_pbr() {
  _create_pbr = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee113(params) {
    return _regeneratorRuntime().wrap(function _callee113$(_context113) {
      while (1) switch (_context113.prev = _context113.next) {
        case 0:
          return _context113.abrupt("return", $.post("/v1/company/vyos/create_pbr/", params));
        case 1:
        case "end":
          return _context113.stop();
      }
    }, _callee113);
  }));
  return _create_pbr.apply(this, arguments);
}
function update_pbr(_x114) {
  return _update_pbr.apply(this, arguments);
}
function _update_pbr() {
  _update_pbr = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee114(params) {
    return _regeneratorRuntime().wrap(function _callee114$(_context114) {
      while (1) switch (_context114.prev = _context114.next) {
        case 0:
          return _context114.abrupt("return", $.put("/v1/company/vyos/update_pbr/", params));
        case 1:
        case "end":
          return _context114.stop();
      }
    }, _callee114);
  }));
  return _update_pbr.apply(this, arguments);
}
function delete_pbr(_x115) {
  return _delete_pbr.apply(this, arguments);
}
function _delete_pbr() {
  _delete_pbr = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee115(params) {
    return _regeneratorRuntime().wrap(function _callee115$(_context115) {
      while (1) switch (_context115.prev = _context115.next) {
        case 0:
          return _context115.abrupt("return", $.post("/v1/company/vyos/delete_pbr/", params));
        case 1:
        case "end":
          return _context115.stop();
      }
    }, _callee115);
  }));
  return _delete_pbr.apply(this, arguments);
}
function get_network_interface(_x116) {
  return _get_network_interface.apply(this, arguments);
}
function _get_network_interface() {
  _get_network_interface = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee116(params) {
    return _regeneratorRuntime().wrap(function _callee116$(_context116) {
      while (1) switch (_context116.prev = _context116.next) {
        case 0:
          return _context116.abrupt("return", $.getJSON("/v1/company/vyos/get_network_interface/", params));
        case 1:
        case "end":
          return _context116.stop();
      }
    }, _callee116);
  }));
  return _get_network_interface.apply(this, arguments);
}
function update_pbr_detail(_x117) {
  return _update_pbr_detail.apply(this, arguments);
}
function _update_pbr_detail() {
  _update_pbr_detail = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee117(params) {
    return _regeneratorRuntime().wrap(function _callee117$(_context117) {
      while (1) switch (_context117.prev = _context117.next) {
        case 0:
          return _context117.abrupt("return", $.post("/v1/company/vyos/update_pbr_detail/", params));
        case 1:
        case "end":
          return _context117.stop();
      }
    }, _callee117);
  }));
  return _update_pbr_detail.apply(this, arguments);
}
function query_acl_config_list(_x118) {
  return _query_acl_config_list.apply(this, arguments);
}
function _query_acl_config_list() {
  _query_acl_config_list = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee118(params) {
    return _regeneratorRuntime().wrap(function _callee118$(_context118) {
      while (1) switch (_context118.prev = _context118.next) {
        case 0:
          return _context118.abrupt("return", $.getJSON("/v1/company/vyos/query_acl_config_list/", params));
        case 1:
        case "end":
          return _context118.stop();
      }
    }, _callee118);
  }));
  return _query_acl_config_list.apply(this, arguments);
}
function create_acl_config(_x119) {
  return _create_acl_config.apply(this, arguments);
}
function _create_acl_config() {
  _create_acl_config = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee119(params) {
    return _regeneratorRuntime().wrap(function _callee119$(_context119) {
      while (1) switch (_context119.prev = _context119.next) {
        case 0:
          return _context119.abrupt("return", $.post("/v1/company/vyos/create_acl_config/", params));
        case 1:
        case "end":
          return _context119.stop();
      }
    }, _callee119);
  }));
  return _create_acl_config.apply(this, arguments);
}
function update_acl_config(_x120) {
  return _update_acl_config.apply(this, arguments);
}
function _update_acl_config() {
  _update_acl_config = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee120(params) {
    return _regeneratorRuntime().wrap(function _callee120$(_context120) {
      while (1) switch (_context120.prev = _context120.next) {
        case 0:
          return _context120.abrupt("return", $.post("/v1/company/vyos/update_acl_config/", params));
        case 1:
        case "end":
          return _context120.stop();
      }
    }, _callee120);
  }));
  return _update_acl_config.apply(this, arguments);
}
function delete_acl_config(_x121) {
  return _delete_acl_config.apply(this, arguments);
}
function _delete_acl_config() {
  _delete_acl_config = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee121(params) {
    return _regeneratorRuntime().wrap(function _callee121$(_context121) {
      while (1) switch (_context121.prev = _context121.next) {
        case 0:
          return _context121.abrupt("return", $.post("/v1/company/vyos/delete_acl_config/", params));
        case 1:
        case "end":
          return _context121.stop();
      }
    }, _callee121);
  }));
  return _delete_acl_config.apply(this, arguments);
}
function active_acl_config(_x122) {
  return _active_acl_config.apply(this, arguments);
}
function _active_acl_config() {
  _active_acl_config = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee122(params) {
    return _regeneratorRuntime().wrap(function _callee122$(_context122) {
      while (1) switch (_context122.prev = _context122.next) {
        case 0:
          return _context122.abrupt("return", $.post("/v1/company/vyos/active_acl_config/", params));
        case 1:
        case "end":
          return _context122.stop();
      }
    }, _callee122);
  }));
  return _active_acl_config.apply(this, arguments);
}
function push_command(_x123) {
  return _push_command.apply(this, arguments);
}
function _push_command() {
  _push_command = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee123(params) {
    return _regeneratorRuntime().wrap(function _callee123$(_context123) {
      while (1) switch (_context123.prev = _context123.next) {
        case 0:
          return _context123.abrupt("return", $.post("/v1/company/push_command/", params));
        case 1:
        case "end":
          return _context123.stop();
      }
    }, _callee123);
  }));
  return _push_command.apply(this, arguments);
}
function bind_vlan_firewall(_x124) {
  return _bind_vlan_firewall.apply(this, arguments);
}
function _bind_vlan_firewall() {
  _bind_vlan_firewall = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee124(params) {
    return _regeneratorRuntime().wrap(function _callee124$(_context124) {
      while (1) switch (_context124.prev = _context124.next) {
        case 0:
          return _context124.abrupt("return", $.post("/v1/company/vyos/bind_vlan_firewall/", params));
        case 1:
        case "end":
          return _context124.stop();
      }
    }, _callee124);
  }));
  return _bind_vlan_firewall.apply(this, arguments);
}
function create_ospf_redistribute_type(_x125) {
  return _create_ospf_redistribute_type.apply(this, arguments);
}
function _create_ospf_redistribute_type() {
  _create_ospf_redistribute_type = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee125(params) {
    return _regeneratorRuntime().wrap(function _callee125$(_context125) {
      while (1) switch (_context125.prev = _context125.next) {
        case 0:
          return _context125.abrupt("return", $.post("/v1/company/vyos/create_ospf_redistribute_type/", params));
        case 1:
        case "end":
          return _context125.stop();
      }
    }, _callee125);
  }));
  return _create_ospf_redistribute_type.apply(this, arguments);
}
function delete_ospf_redistribute_type(_x126) {
  return _delete_ospf_redistribute_type.apply(this, arguments);
}
function _delete_ospf_redistribute_type() {
  _delete_ospf_redistribute_type = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee126(params) {
    return _regeneratorRuntime().wrap(function _callee126$(_context126) {
      while (1) switch (_context126.prev = _context126.next) {
        case 0:
          return _context126.abrupt("return", $.post("/v1/company/vyos/delete_ospf_redistribute_type/", params));
        case 1:
        case "end":
          return _context126.stop();
      }
    }, _callee126);
  }));
  return _delete_ospf_redistribute_type.apply(this, arguments);
}
function update_ospf_redistribute_type(_x127) {
  return _update_ospf_redistribute_type.apply(this, arguments);
}
function _update_ospf_redistribute_type() {
  _update_ospf_redistribute_type = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee127(params) {
    return _regeneratorRuntime().wrap(function _callee127$(_context127) {
      while (1) switch (_context127.prev = _context127.next) {
        case 0:
          return _context127.abrupt("return", $.post("/v1/company/vyos/update_ospf_redistribute_type/", params));
        case 1:
        case "end":
          return _context127.stop();
      }
    }, _callee127);
  }));
  return _update_ospf_redistribute_type.apply(this, arguments);
}
function query_ospf_redistribute_type(_x128) {
  return _query_ospf_redistribute_type.apply(this, arguments);
}
function _query_ospf_redistribute_type() {
  _query_ospf_redistribute_type = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee128(params) {
    return _regeneratorRuntime().wrap(function _callee128$(_context128) {
      while (1) switch (_context128.prev = _context128.next) {
        case 0:
          return _context128.abrupt("return", $.getJSON("/v1/company/vyos/query_ospf_redistribute_type/", params));
        case 1:
        case "end":
          return _context128.stop();
      }
    }, _callee128);
  }));
  return _query_ospf_redistribute_type.apply(this, arguments);
}
function query_device_ip_group(_x129) {
  return _query_device_ip_group.apply(this, arguments);
}
function _query_device_ip_group() {
  _query_device_ip_group = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee129(params) {
    return _regeneratorRuntime().wrap(function _callee129$(_context129) {
      while (1) switch (_context129.prev = _context129.next) {
        case 0:
          return _context129.abrupt("return", $.post("/v1/company/query_device_ip_group/", params));
        case 1:
        case "end":
          return _context129.stop();
      }
    }, _callee129);
  }));
  return _query_device_ip_group.apply(this, arguments);
}
function create_device_ip_group(_x130) {
  return _create_device_ip_group.apply(this, arguments);
}
function _create_device_ip_group() {
  _create_device_ip_group = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee130(params) {
    return _regeneratorRuntime().wrap(function _callee130$(_context130) {
      while (1) switch (_context130.prev = _context130.next) {
        case 0:
          return _context130.abrupt("return", $.post("/v1/company/create_device_ip_group/", params));
        case 1:
        case "end":
          return _context130.stop();
      }
    }, _callee130);
  }));
  return _create_device_ip_group.apply(this, arguments);
}
function update_device_ip_group(_x131) {
  return _update_device_ip_group.apply(this, arguments);
}
function _update_device_ip_group() {
  _update_device_ip_group = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee131(params) {
    return _regeneratorRuntime().wrap(function _callee131$(_context131) {
      while (1) switch (_context131.prev = _context131.next) {
        case 0:
          return _context131.abrupt("return", $.post("/v1/company/update_device_ip_group/", params));
        case 1:
        case "end":
          return _context131.stop();
      }
    }, _callee131);
  }));
  return _update_device_ip_group.apply(this, arguments);
}
function delete_device_ip_group(_x132) {
  return _delete_device_ip_group.apply(this, arguments);
}
function _delete_device_ip_group() {
  _delete_device_ip_group = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee132(params) {
    return _regeneratorRuntime().wrap(function _callee132$(_context132) {
      while (1) switch (_context132.prev = _context132.next) {
        case 0:
          return _context132.abrupt("return", $.post("/v1/company/delete_device_ip_group/", params));
        case 1:
        case "end":
          return _context132.stop();
      }
    }, _callee132);
  }));
  return _delete_device_ip_group.apply(this, arguments);
}
function unbind_ip_group(_x133) {
  return _unbind_ip_group.apply(this, arguments);
}
function _unbind_ip_group() {
  _unbind_ip_group = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee133(params) {
    return _regeneratorRuntime().wrap(function _callee133$(_context133) {
      while (1) switch (_context133.prev = _context133.next) {
        case 0:
          return _context133.abrupt("return", $.post("/v1/company/unbind_ip_group/", params));
        case 1:
        case "end":
          return _context133.stop();
      }
    }, _callee133);
  }));
  return _unbind_ip_group.apply(this, arguments);
}
export { get_cta_wan, create_cta_wan, update_cta_wan, delete_cta_wan, check_lan_only, get_isp_dict, get_available_ports_for_wan, get_cta_lan, create_cta_lan, update_cta_lan, delete_cta_lan, get_cta_wifi, get_cta_static_ip, create_cta_static_ip, update_cta_static_ip, delete_cta_static_ip, create_cta_wifi, update_cta_wifi, delete_cta_wifi, get_cpe_template_agency, get_physical_ports_info, update_cpe_template_agency, get_cta_static_route, create_cta_static_route, update_cta_static_route, delete_cta_static_route, get_cta_static_parse, create_cta_static_parse, update_cta_static_parse, delete_cta_static_parse, get_ap_wifi, get_ap_lan, get_ipset_by_cta_lan, update_agency, create_ap_lan, update_ap_lan, delete_ap_lan, create_ap_wifi, update_ap_wifi, delete_ap_wifi, get_latest_lan_name, get_ap_static_ip, create_ap_static_ip, update_ap_static_ip, delete_ap_static_ip, get_start_end_ip, get_tunnel_snat, create_tunnel_snat, delete_tunnel_snat, update_tunnel_snat, get_tunnel_dnat, create_tunnel_dnat, delete_tunnel_dnat, update_tunnel_dnat, get_available_ports_for_vlan, get_cta_vlan, create_cta_vlan, update_cta_vlan, delete_cta_vlan, get_cta_dnat, create_cta_dnat, update_cta_dnat, delete_cta_dnat, get_crash, create_multi_dns, update_multi_dns, delete_multi_dns, get_multi_dns, get_step_userinfo, get_centre_agency_detail, create_vyos_lan, update_vyos_lan, delete_vyos_lan, get_vyos_lan, bind_vyos_dhcp, create_vyos_vlan, update_vyos_vlan, delete_vyos_vlan, bind_wan_firewall, bind_redirect_ip, bind_wan_snat, bind_wan_dns_interception, get_policy_number_range, bind_tunnel_flow, create_vyos_wan, update_vyos_wan, delete_vyos_wan, get_vyos_wan, get_available_ports, get_interface_alias, get_vyos_physical_ports_info, get_vyos_static_route, create_vyos_static_route, update_vyos_static_route, delete_vyos_static_route, get_vyos_vlan, get_bgp, create_bgp, query_bgp_neighbor_list, create_bgp_neighbor, update_bgp_neighbor, delete_bgp_neighbor, update_ospf, query_ospf_area_list, create_ospf_area, update_ospf_area, delete_ospf_area, create_ospf_area_network, query_ospf_area_network, delete_ospf_area_network, update_ospf_area_network, query_pbr_list, create_pbr, update_pbr, delete_pbr, get_network_interface, update_pbr_detail, query_acl_config_list, create_acl_config, update_acl_config, delete_acl_config, active_acl_config, push_command, bind_vlan_firewall, create_ospf_redistribute_type, delete_ospf_redistribute_type, update_ospf_redistribute_type, query_ospf_redistribute_type, query_device_ip_group, create_device_ip_group, update_device_ip_group, delete_device_ip_group, unbind_ip_group };